import {
  ensurePermissionMap,
  normalizeAmpiOrganizationUser,
} from "../../common/ampiOrganizationUserAccess";

const readPersistedUser = () => {
  try {
    const raw = localStorage.getItem("USER_PROFILE");
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch (err) {
    return {};
  }
};

const persistedUser = ensurePermissionMap(
  normalizeAmpiOrganizationUser(readPersistedUser())
);

export default {
  loggedIn: Boolean(persistedUser._id),
  user: persistedUser,
  organizationContext: persistedUser.organizationContext || null,
  organizationProfilePicture: "",
  token: localStorage.getItem("USER_TOKEN") || "",
  indicators: {
    totalItems: 0,
    unassignedItems: 0,
    assignedItems: 0,
    soldItems: 0,
    orderPaymentPendingItems: 0
  },
}
